const vehicleReport = {
  title: 'דו"ח נסיעות רכב',
  description:'מספק מידע סטטיסטי על פעילות נהגים בודדים.',
  table: {
    headers: {
      id: 'מזהה',
      vehicle: 'רכב',
      driver: 'נהג',
      supplier: 'ספק',
      zones: 'אזורים',
      locations: 'מיקומים',
      profiles: 'פרופילים',
      attributes: 'מאפיינים',
      trips: 'נסיעות',
      driverShifts: 'משמרת',
      start: 'התחלה',
      departureTime: 'זמן יציאה',  
      end: 'סיום',
      hours: 'שעות',
      jobs: 'הזמנות',
      tripDuration: 'משך הנסיעה',
      tripDistance: 'מרחק הנסיעה',
      distanceToPickUp: 'מרחק לאיסוף',
      amount: 'סכום',
      booking: 'הזמנה',
      totalDistance: 'מרחק כולל',
      loadedDistance: 'מרחק עם נוסע',
      earningPerHour: 'הכנסה לשעה',
      cost: 'עלות',
    },
    driver: 'נהג',
    Amount: 'סכום',
    unassignedTrips: 'לא משויך',
    yes: 'כן',
    no: 'לא',
  },

  filter: {
    export: 'ייצא',
    driver: 'נהג',
    supplier: 'ספק',
    car: 'רכב',
    zones: 'אזורים',
    locations: 'מיקומים',
    airportLocations: 'מיקומי שדה תעופה',
    profiles: 'פרופילים',
    attributes: 'מאפיינים',
    submit: 'סינון',
    clear: 'נקה סינון',
    driverShifts: {
      title: 'משמרות נהגים',
      options: {
        withShifts: 'עם משמרת',
        withoutShifts: 'בלי משמרת'
      }
    },
    validation: {
      startDateRequired: 'תאריך התחלה נדרש',
      endDateRequired: 'תאריך סיום נדרש',
    },
  },

  vehicleSummary: {
    total: 'רכבים',
    totalTrips: 'נסיעות',
    totalReservation: 'הזמנות',
    loadedDistance: 'מרחק טעון',
    totalCost: 'עלות כוללת',
  },

  form: {
    dateEnd: 'תאריך סיום',
    dateStart: 'תאריך התחלה',
  },
  export: 'דו"ח רכב'
};

export default vehicleReport;
